// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfileForm__form-cfd029 {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.EditProfileForm__form-content-b7b0c2 {
  flex: 1;
  padding: 16px 0;
  overflow: auto;
}

.EditProfileForm__form-actions-f95caa {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
}

.EditProfileForm__image-field-a81d2a {
  margin-bottom: 32px;
}

.EditProfileForm__form-field-b11897 {
  margin-bottom: 12px;
}

.EditProfileForm__form-section-fa635b {
  padding: 0 24px;
}

.EditProfileForm__section-name-c65d0a {
  font: var(--font-subtitle-1);
  color: var(--base-80);
  margin: 16px 0px;
  letter-spacing: var(--font-spacing-body-1);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/EditProfilePopup/EditProfileForm/EditProfileForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;AACF;;AAEA;EACE,OAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,0CAAA;AACF","sourcesContent":[".form {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n}\n\n.form-content {\n  flex: 1;\n  padding: 16px 0;\n  overflow: auto;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 24px;\n}\n\n.image-field {\n  margin-bottom: 32px;\n}\n\n.form-field {\n  margin-bottom: 12px;\n}\n\n.form-section {\n  padding: 0 24px;\n}\n\n.section-name {\n  font: var(--font-subtitle-1);\n  color: var(--base-80);\n  margin: 16px 0px;\n  letter-spacing: var(--font-spacing-body-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `EditProfileForm__form-cfd029`,
	"form-content": `EditProfileForm__form-content-b7b0c2`,
	"formContent": `EditProfileForm__form-content-b7b0c2`,
	"form-actions": `EditProfileForm__form-actions-f95caa`,
	"formActions": `EditProfileForm__form-actions-f95caa`,
	"image-field": `EditProfileForm__image-field-a81d2a`,
	"imageField": `EditProfileForm__image-field-a81d2a`,
	"form-field": `EditProfileForm__form-field-b11897`,
	"formField": `EditProfileForm__form-field-b11897`,
	"form-section": `EditProfileForm__form-section-fa635b`,
	"formSection": `EditProfileForm__form-section-fa635b`,
	"section-name": `EditProfileForm__section-name-c65d0a`,
	"sectionName": `EditProfileForm__section-name-c65d0a`
};
module.exports = ___CSS_LOADER_EXPORT___;
